import {requirePermission} from '@/modules/auth/permissions'
import {openMappingDialog} from '@/modules/smart-compounders/components/mapping-dialog'
import {MappingsTable} from '@/modules/smart-compounders/components/mappings-table'
import {ResourcesIndexPageHeader} from '@/shared/components/ui/resources-index-page-header'
import {ResourcesIndexPageTable} from '@/shared/components/ui/resources-index-page-table'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/configuration/smart-compounders/mappings')({
  beforeLoad: requirePermission('interfaces.manage'),
  component: MappingsPage,
})

function MappingsPage() {
  const {t} = useTranslate('common')

  return (
    <ResourcesIndexPageTable>
      <ResourcesIndexPageHeader
        title={t('smart_compounder_mappings')}
        description={t('smart_compounder_mappings_description')}
        onAddNew={openMappingDialog}
      />
      <MappingsTable />
    </ResourcesIndexPageTable>
  )
}
